import React from "react";

/**
 * Original brand icons for HR ENTERPRISES divisions.
 * Shared design language: 40x40 viewBox, 1.4 stroke, no fill,
 * gold accent line, one solid geometric anchor. Uses currentColor.
 */

const base = {
  width: 22,
  height: 22,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

// AURIX STUDIO — abstract "A" pillar + horse-motion arc (matches ecosystem)
export const StudioIcon = ({ className = "" }) => (
  <svg {...base} className={className} stroke="currentColor">
    <path d="M8 32 L20 8 L32 32" />
    <path d="M14 24 H26" />
    <path d="M6 34 Q20 22 34 34" strokeOpacity="0.35" />
  </svg>
);

// AURIX MEDIA — aperture / play prism (creative geometry)
export const MediaIcon = ({ className = "" }) => (
  <svg {...base} className={className} stroke="currentColor">
    <circle cx="20" cy="20" r="12" />
    <path d="M17 15 L26 20 L17 25 Z" fill="currentColor" fillOpacity="0.85" stroke="none" />
    <path d="M20 4 V8 M20 32 V36 M4 20 H8 M32 20 H36" strokeOpacity="0.5" />
  </svg>
);

// AURIX GROWTH — upward arrow with connected node chart
export const GrowthIcon = ({ className = "" }) => (
  <svg {...base} className={className} stroke="currentColor">
    <path d="M6 30 L14 22 L20 26 L28 14 L34 18" />
    <path d="M28 10 H34 V16" />
    <circle cx="14" cy="22" r="1.6" fill="currentColor" stroke="none" />
    <circle cx="20" cy="26" r="1.6" fill="currentColor" stroke="none" />
    <circle cx="28" cy="14" r="1.6" fill="currentColor" stroke="none" />
  </svg>
);

// AURIX FMCG LABS — molecular leaf (nature + innovation)
export const FmcgIcon = ({ className = "" }) => (
  <svg {...base} className={className} stroke="currentColor">
    <path d="M10 30 C10 18, 22 10, 32 8 C30 20, 22 30, 10 30 Z" />
    <path d="M10 30 L22 18" strokeOpacity="0.55" />
    <circle cx="14" cy="26" r="2" fill="currentColor" stroke="none" />
    <circle cx="22" cy="18" r="2" fill="currentColor" stroke="none" />
    <circle cx="30" cy="12" r="2" fill="currentColor" stroke="none" />
    <path d="M14 26 L22 18 L30 12" strokeOpacity="0.35" />
  </svg>
);

export const ICONS = {
  studio: StudioIcon,
  media: MediaIcon,
  growth: GrowthIcon,
  fmcg: FmcgIcon,
};
